<div [ngClass]="{'flex-column': !dense}" class="d-flex align-items-center justify-content-center">
    <fa-icon
        [icon]="['far', 'spinner']"
        animation="spin-pulse"
        size="lg"
    ></fa-icon>
    <p [ngClass]="dense ? 'ml-2' : 'mt-2'" class="m-0">{{ 'common.items-are-being-loaded' | translate : { value: resource } }}</p>
</div>
